import { YWT_PUBLIC_CONFIG } from '@cuspar/ywt.ch.config/public';
import type { AnalyticsConsent } from '../state/preferencesStore';

type ClarityFunction = ((...args: unknown[]) => void) & { q?: unknown[][] };

declare global {
  interface Window {
    clarity?: ClarityFunction;
  }
}

const PROJECT_ID = YWT_PUBLIC_CONFIG.clarity.projectId;

/** Clarity only runs where a project is configured (production and dev, each with its own project). */
export const clarityEnabled = Boolean(PROJECT_ID);

/** Pages that show customer data; their text is masked in Clarity recordings. */
export function isPrivatePath(pathname: string): boolean {
  return /^\/(account|admin|checkout)(\/|$)/.test(pathname);
}

/**
 * Loads Microsoft Clarity (the vendor's loader, unchanged in behaviour): calls
 * made before the script arrives are queued on `window.clarity.q`.
 */
export function startClarity(): void {
  if (!clarityEnabled || typeof window === 'undefined' || window.clarity) return;

  const clarity: ClarityFunction = (...args: unknown[]) => {
    (clarity.q = clarity.q || []).push(args);
  };
  window.clarity = clarity;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${PROJECT_ID}`;
  document.head.appendChild(script);
}

/**
 * Tells Clarity what the visitor allowed. Without analytics consent (declined,
 * or not answered yet) Clarity sets no cookies and treats every page view on
 * its own. Advertising storage is never granted: we run no ads.
 */
export function sendClarityConsent(consent: AnalyticsConsent | null): void {
  if (!clarityEnabled || typeof window === 'undefined') return;
  window.clarity?.('consentv2', { ad_Storage: 'denied', analytics_Storage: consent === 'granted' ? 'granted' : 'denied' });
}
